import { takeLatest, takeEvery } from "redux-saga/effects";

import {
  handleUserLogin,
  handleConfirmEmail,
  handleVerificationCode,
  handleUserPassword,
  handleMainUserLogin,
  handleResendOtp,
} from "./handlers/auth";
import {
  LOGIN,
  CONFIRM_EMAIL,
  VERIFICATION_CODE,
  USER_PWD,
  SET_MAIN_USER_LOGIN,
  SET_RESEND_OTP,
} from "../ducks/auth";

import {
  GET_PROVIDER_DATA,
  GET_PROVIDER_CATEGORIES,
  GET_PROVIDER_DATA_BY_NAME,
  GET_PROVIDER_NAME_PREDICTION,
  GET_CPT_CODE_SUGGESTION,
  GET_PROVIDER_SEARCH_DATA_BY_CPT,
  GET_PROVIDER_API_CALL_COUNT_BY_CLIENT,
  GET_PROVIDER_SEARCH_DATA_BY_FACILITY,
  GET_COMMENT,
  ADD_COMMENT,
  ADD_CLAIM,
  ADD_PROVIDER_LIKE,
  GET_USER_ACTIVITY,
  GET_USERS_ACTIVITY,
  GET_PROVIDER_DATA_BY_NPI,
  GET_AI_SEARCH_RESULT,
} from "../ducks/provider";
import {
  handleGetProviderCategory,
  handleGetProviderSearchData,
  handleGetProviderNamePrediction,
  handleGetProviderApiCallCountByClient,
  handleGetProviderSearchDataByName,
  handleGetCptSuggestion,
  handleGetProviderSearchDataByCPT,
  handleGetProviderSearchDataByFacility,
  handleAddProviderComment,
  handleGetProviderComment,
  handleAddProviderLikeFeedback,
  handleGetUsersActivity,
  handleGetUserActivity,
  handleGetProviderSearchDataByNpi,
  handleAddProviderClaim,
  handleGetNPIActivity,
} from "./handlers/provider";

import {
  GET_CREATE_USER,
  GET_ROLES,
  GET_UPDATE_USER,
  GET_UPDATE_USER_ACCESS,
  GET_UPDATE_USER_TO_ADMIN_OR_NOT,
  GET_USER_DETAILS,
  GET_USER_DETAILS_BY_CLIENTID,
  GET_ALL_USERS_UNDER_CLIENT_ADMIN,
  GET_USER_DETAILS_BY_TOKEN,
  GET_UPDATE_USER_TNC_ACCEPTANCE,
} from "../ducks/user";
import {
  handleGetCreateUser,
  handleGetUpdateUser,
  handleGetUpdateUserAccess,
  handleGetUpdateUserToAdminOrNot,
  handleGetUserDetails,
  handleGetUserDetailsByClientId,
  handleGetUserDetailsByToken,
  handleGetUserDetailsUnderClientAdmin,
  handleSetRoles,
  handleUpdateUserTnCAcceptance,
} from "./handlers/user";

import {
  DELETE_CLIENT_DETAILS_BY_ID,
  GET_ALL_CLIENT_UNDER_SYSTEM_ADMIN,
  GET_CLIENT_DETAILS_BY_TOKEN,
  GET_CLIENT_DETAILS_BY_ID,
  CREATE_CLIENT,
  UPDATE_CLIENT_ACCESS,
  UPDATE_CLIENT,
} from "../ducks/organization";
import {
  handleCreateClient,
  handleDeleteClient,
  handleGetAllClients,
  handleGetClient,
  handleGetClientByToken,
  handleUpdateClient,
  handleUpdateClientAccess,
} from "./handlers/organization";

import {
  PLACE_CALL,
  GET_CALL_STATUS,
  END_CALL,
  GET_RECORDING,
  GET_JOBS,
  GET_DOCTOR_LOGS,
  GET_BILLING_LOGS,
  IMPORT_CALL,
  GET_TRANSCRIPT,
} from "../ducks/aiVerificationCall";
import {
  handlePlaceCall,
  handleGetCallStatus,
  handleEndCall,
  handleGetRecording,
  handleGetJobs,
  handleGetDoctorLogs,
  handleGetBillingLogs,
  handleImportCall,
  handleGetTranscript,
} from "./handlers/aiVerificationCall";

// all of the of the watcher would go here
export function* watcherSaga() {
  //auth
  yield takeLatest(LOGIN, handleUserLogin);
  yield takeLatest(SET_MAIN_USER_LOGIN, handleMainUserLogin);
  yield takeLatest(SET_RESEND_OTP, handleResendOtp);
  yield takeLatest(CONFIRM_EMAIL, handleConfirmEmail);
  yield takeLatest(VERIFICATION_CODE, handleVerificationCode);
  yield takeLatest(USER_PWD, handleUserPassword);

  //provider
  yield takeLatest(GET_PROVIDER_DATA, handleGetProviderSearchData);
  yield takeLatest(GET_PROVIDER_CATEGORIES, handleGetProviderCategory);
  yield takeLatest(
    GET_PROVIDER_NAME_PREDICTION,
    handleGetProviderNamePrediction
  );
  yield takeLatest(
    GET_PROVIDER_DATA_BY_NAME,
    handleGetProviderSearchDataByName
  );
  yield takeLatest(GET_CPT_CODE_SUGGESTION, handleGetCptSuggestion);
  yield takeLatest(
    GET_PROVIDER_SEARCH_DATA_BY_CPT,
    handleGetProviderSearchDataByCPT
  );
  yield takeLatest(
    GET_PROVIDER_API_CALL_COUNT_BY_CLIENT,
    handleGetProviderApiCallCountByClient
  );
  yield takeLatest(
    GET_PROVIDER_SEARCH_DATA_BY_FACILITY,
    handleGetProviderSearchDataByFacility
  );
  yield takeLatest(GET_PROVIDER_DATA_BY_NPI, handleGetProviderSearchDataByNpi);

  yield takeLatest(GET_COMMENT, handleGetProviderComment);
  yield takeLatest(ADD_COMMENT, handleAddProviderComment);
  yield takeLatest(ADD_PROVIDER_LIKE, handleAddProviderLikeFeedback);
  yield takeLatest(GET_USERS_ACTIVITY, handleGetUsersActivity);
  yield takeLatest(GET_USER_ACTIVITY, handleGetUserActivity);
  yield takeLatest(GET_AI_SEARCH_RESULT, handleGetNPIActivity);
  yield takeLatest(ADD_CLAIM, handleAddProviderClaim);

  //user

  yield takeLatest(
    GET_UPDATE_USER_TNC_ACCEPTANCE,
    handleUpdateUserTnCAcceptance
  );
  yield takeLatest(GET_USER_DETAILS, handleGetUserDetails);
  yield takeLatest(GET_CREATE_USER, handleGetCreateUser);
  yield takeLatest(
    GET_USER_DETAILS_BY_CLIENTID,
    handleGetUserDetailsByClientId
  );
  yield takeLatest(GET_USER_DETAILS_BY_TOKEN, handleGetUserDetailsByToken);
  yield takeLatest(
    GET_ALL_USERS_UNDER_CLIENT_ADMIN,
    handleGetUserDetailsUnderClientAdmin
  );
  yield takeLatest(GET_UPDATE_USER, handleGetUpdateUser);
  yield takeLatest(GET_UPDATE_USER_ACCESS, handleGetUpdateUserAccess);
  yield takeLatest(
    GET_UPDATE_USER_TO_ADMIN_OR_NOT,
    handleGetUpdateUserToAdminOrNot
  );
  yield takeLatest(GET_ROLES, handleSetRoles);

  //organization
  yield takeLatest(CREATE_CLIENT, handleCreateClient);
  yield takeLatest(UPDATE_CLIENT, handleUpdateClient);
  yield takeLatest(GET_ALL_CLIENT_UNDER_SYSTEM_ADMIN, handleGetAllClients);
  yield takeLatest(GET_CLIENT_DETAILS_BY_ID, handleGetClient);
  yield takeLatest(GET_CLIENT_DETAILS_BY_TOKEN, handleGetClientByToken);
  yield takeLatest(DELETE_CLIENT_DETAILS_BY_ID, handleDeleteClient);
  yield takeLatest(UPDATE_CLIENT_ACCESS, handleUpdateClientAccess);

  //aiVerificationCall
  yield takeLatest(PLACE_CALL, handlePlaceCall);
  yield takeLatest(GET_CALL_STATUS, handleGetCallStatus);
  yield takeLatest(END_CALL, handleEndCall);
  // per-row fetches — takeEvery so concurrent rows don't cancel each other
  yield takeEvery(GET_RECORDING, handleGetRecording);
  yield takeLatest(GET_JOBS, handleGetJobs);
  yield takeEvery(GET_DOCTOR_LOGS, handleGetDoctorLogs);
  yield takeLatest(GET_BILLING_LOGS, handleGetBillingLogs);
  yield takeLatest(IMPORT_CALL, handleImportCall);
  yield takeEvery(GET_TRANSCRIPT, handleGetTranscript);
}
